module.exports = __webpack_public_path__ + "static/media/farmer-on-the-frontline-thumbnail_desktop.ffee85c7.jpg";